import { env } from '@env';
import { GetCustomerOverviewResponse } from './Types';
import { httpUtil } from '@/framework';
import { GetCustomerReportRequest } from '../Types';

export const getCustomerTotalOverview = httpUtil.createHttpRequestMeta<
    GetCustomerReportRequest,
    GetCustomerOverviewResponse
>({
    baseUrl: env.orgServer,
    path: '/customers/total-overview',
    method: 'GET',
    authentication: 'bearer'
});
